import * as React from 'react'
export const FacebookIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.3333 0H2.66667C1.19389 0 0 1.19389 0 2.66667V17.3333C0 18.8061 1.19389 20 2.66667 20H8.42167V12.4573H5.82722V9.70067H8.42167V7.86678C8.42167 4.83011 9.90122 3.49733 12.4251 3.49733C13.6338 3.49733 14.2736 3.58678 14.5759 3.62767V6.03333H12.8544C11.7832 6.03333 11.4091 7.04878 11.4091 8.194V9.70078H14.5494L14.1233 12.4574H11.4097V20H17.3333C18.8061 20 20 18.8061 20 17.3333V2.66667C20 1.19389 18.8061 0 17.3333 0Z'
        fill='current'
      />
    </svg>
  )
}
